import { HIDE_SENSITIVE_MODAL, SHOW_SENSITIVE_MODAL } from "../actions/sensitiveContent/constants";


const initialState = {
  showModal: false,
  typeModal: null,
};

const sensitiveContent = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SENSITIVE_MODAL:
      return { ...state, showModal: true, typeModal: action?.payload};
    case HIDE_SENSITIVE_MODAL:
      return initialState;
    default:
      return state;
  }
};
export default sensitiveContent;
